import { useOutlet } from "react-router-dom";
import { useEffect, useState, memo, useMemo, useCallback } from "react";
import { debounce } from "lodash-es";
import { Affix } from "antd";
import { isInIframe } from "@/utils";
import { Search } from "./search";
import { Footer } from "./footer";
import { SSearch } from "./search";
import { Header } from "./head";
import styles from "./style.module.scss";

export type LayoutPropsType = {
  layout?: "horzontal" | "vertical";
};

export const Layout = memo((props: LayoutPropsType) => {
  const outlet = useOutlet();
  const [affixOffsetTop, setAffixOffsetTop] = useState(0);
  const [selectTab, setSelectTab] = useState("supplier");

  const handleScroll = useCallback(
    debounce(() => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setAffixOffsetTop(scrollTop);
    }, 10),
    [],
  );

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      handleScroll.cancel(); // Clean up debounced function
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  const main = useMemo(() => {
    return (
      <>
        <div className={styles.outLayoutWrapper}>
          <div className={styles.layoutWrapper}>
            <div className={styles.layoutContent}>{outlet}</div>
          </div>
        </div>
        <div style={{ maxWidth: 1200, margin: "0 auto", minWidth: 0 }}>
          <Footer />
        </div>
      </>
    );
  }, [outlet]);

  const handleTabChange = (key: string) => {
    setSelectTab(key);
  };

  return (
    <div className={styles.globalWrapper}>
      {!isInIframe() && <Header noTabs />}
      {affixOffsetTop > 44 ? (
        <Affix offsetTop={0} style={{ zIndex: 1000 }}>
          <SSearch onTabChange={handleTabChange} />
        </Affix>
      ) : (
        <SSearch onTabChange={handleTabChange} />
      )}
      <Search {...props} noSearch />
      <div style={{ marginTop: 0 }}>{main}</div>
    </div>
  );
});

export { SimpleLayout } from "./simple-layout";
export { SearchLayout } from "./search-layout";
export { SearchLayoutWide } from "./search-layout-wide";
export { SimpleBusinessLayout } from "./simple-business-layout";
export { SimplePortalLayout } from "./simple-portal-layout";
export { ProductDetailLayout } from "./product-detail-layout";
export { PlainLayout } from "./plain-layout";
export { HeaderFooterLayout } from "./header-footer-layout";
export { SingleTitleLayout } from "./single-title-layout";
export { GypHeaderFooterLayout } from "./gyp-header-footer-layou";
export { SearchLayoutEnterprise } from "./search-layout-enterprise";
